import type { ExtensionConfig } from '@goto/shell'
import { LaunchDarklyVariations } from '../models/feature-flag.models'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@goto/contacts-ui-extension',
  get url() {
    const version = getLaunchDarklyFlag(LaunchDarklyVariations.CONTACTS_VERSIONS)?.extension ?? 'latest'
    return new URL(`/experiences/contacts/${version}/extension/index.js`, location.origin)
  },
  prerequisites: {
    roles: 'jive || gotoconnect',
  },
}

export default extensionConfig
